import * as React from 'react';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import Formsy from 'formsy-react';
import Q from 'q';

import SamlValidationUtils from 'bundles/common/utils/samlValidationUtils';
import S3FileUploader from 'bundles/internal-enterprise/components/S3FileUploader';
import Modal from 'bundles/internal-ui/components/modal/Modal';

import _t from 'i18n!nls/internal-enterprise';

type Props = {
  onSubmit: () => void;
  organization: {
    id: string;
    entityId?: string | undefined | null;
  };
  closeModal: () => void;
};

type State = {
  message: string | null;
};

class UploadSamlMetadataModal extends React.Component<Props, State> {
  state: State = {
    message: null,
  };

  onUpload = () => {
    this.setState({ message: 'Successfully uploaded metadata!' });
    const { onSubmit } = this.props;
    onSubmit();
  };

  onError = (message: string) => {
    this.setState({ message });
  };

  onValidate = (input?: HTMLInputElement) => {
    // skip validation if no file uploaded or no browser support for FileReader / DOMParser
    if (!window.FileReader || !window.DOMParser || !input || !input.files || !input.files[0]) {
      return true;
    }

    const file = input.files[0];
    const reader = new FileReader();
    const deferred = Q.defer();
    reader.onload = () => {
      this.validateSAML(reader, deferred);
    };
    reader.readAsText(file);
    return deferred.promise as Q.Promise<boolean>;
  };

  validateSAML(fileReader: FileReader, deferred: object) {
    const { organization } = this.props;
    const parser = new DOMParser();
    const doc = parser.parseFromString(fileReader.result as string, 'application/xml');
    const validationErrorMessage = SamlValidationUtils.getMetadataValidationMessage(doc, organization);

    this.setState(
      () => ({
        message: validationErrorMessage,
      }),
      () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error TSMIGRATION
        deferred.resolve(!validationErrorMessage); // resolve whether the metadata file validated
      }
    );
  }

  render() {
    const { organization, closeModal } = this.props;
    const { message } = this.state;

    return (
      <Modal
        title={_t('Upload SAML Metadata')}
        onRequestClose={closeModal}
        open
        scrollable
        actions={[
          {
            text: _t('Close'),
            onClick: closeModal,
            style: 'danger',
          },
        ]}
      >
        <Formsy>
          <S3FileUploader
            label="SAML Metadata"
            name="samlMetadata"
            tooltip="XML metadata from SAML IdP"
            signingUrl={`/api/thirdPartyOrganizations.v1?action=getMetadataUploadUrl&id=${organization.id}`}
            onFinish={this.onUpload}
            validateFile={this.onValidate}
            onError={this.onError}
          />
        </Formsy>
        {message}
      </Modal>
    );
  }
}

export default UploadSamlMetadataModal;
